export default __webpack_public_path__ + "static/media/provesional_restoration_upper_13_4@2x.ada7e567.png";